import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const getAuthHeaders = () => {
  const token = localStorage.getItem("tali_client_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Apply for membership
 */
export const applyForMembership = async (applicationData) => {
  try {
    const response = await axios.post(
      `${BASE_API}/memberships/apply`,
      applicationData,
      { headers: getAuthHeaders() }
    );
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get user's membership status
 */
export const getMyMembershipStatus = async () => {
  try {
    const response = await axios.get(`${BASE_API}/memberships/my-status`, {
      headers: getAuthHeaders(),
    });
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get membership details
 */
export const getMembershipDetails = async (id) => {
  try {
    const response = await axios.get(`${BASE_API}/memberships/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Initialize payment for approved membership
 */
export const initializeMembershipPayment = async (id) => {
  try {
    const response = await axios.get(`${BASE_API}/memberships/${id}/payment`, {
      headers: getAuthHeaders(),
    });
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Check payment status
 */
export const getPaymentStatus = async (purchaseId) => {
  try {
    const response = await axios.get(`${BASE_API}/memberships/payment/${purchaseId}/status`, {
      headers: getAuthHeaders(),
    });
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};
